import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-mitteilung-berechtigung-alt';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungMitteilungBerechtigungALTEffects {

    VeranstaltungMitteilungBerechtigungALT$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG_ALT),
        mergeMap((x: ac.GetVeranstaltungMitteilungBerechtigungALTAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungMitteilungBerechtigungALT(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungMitteilungBerechtigungALTErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungMitteilungBerechtigungALTFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
